export const getShareLink = state => medium => {
  console.log(medium, state.shareLinks, state.shareLinks[medium]);
  return state.shareLinks[medium];
};
export const getResultsText = state => {
  const { siteSettings } = state;
  return state.isOwnerOfResults
    ? siteSettings["resultsText"]
    : siteSettings["resultsSharedText"];
};
export const isOnFirstQuestion = state => {
  const { questionsArray } = state;
  if (questionsArray) {
    return (
      questionsArray.findIndex(step => {
        return step.id === state.currentStep;
      }) === 0
    );
  }
};
